const modalModule = {
  state: {
    show: false,
  },
  mutations: {
    showLoading(state, payload) {
      state.show = true;
    },
    hideLoading(state, payload) {
      state.show = false;
    },
  },
  actions: {
    showLoading({ commit }, payload) {
      commit('showLoading', payload);
    },

    hideLoading({ commit }, payload) {
      commit('hideLoading', payload);
    },
  },
  getters: {
    getSpinState: state => {
      return {
        show: state.show,
      };
    },
  },
};

export default modalModule;



// WEBPACK FOOTER //
// ./src/store/modules/spin.js